import type {
  ListBoxItemProps as RAListBoxItemProps,
  ListBoxProps as RAListBoxProps,
} from "react-aria-components";
import {
  ListBox as RAListBox,
  ListBoxItem as RAListBoxItem,
} from "react-aria-components";
import { twMerge } from "tailwind-merge";

interface ListboxItemProps extends RAListBoxItemProps {
  readonly className?: string;
}

interface ListboxProps<T extends object> extends RAListBoxProps<T> {
  readonly className?: string;
}

function ListboxItem({ className, ...props }: Readonly<ListboxItemProps>) {
  return (
    <RAListBoxItem
      {...props}
      className={twMerge(
        `group text-text-primary hover:bg-background/60 aria-selected:border-primary aria-selected:bg-primary/20 aria-selected:text-listbox-selected-text flex w-full flex-row items-center gap-3 rounded-lg border border-transparent p-3 text-sm transition-colors duration-200`,
        className,
      )}
    />
  );
}

export default function Listbox<T extends object>({
  className,
  ...props
}: Readonly<ListboxProps<T>>) {
  return (
    <RAListBox<T>
      {...props}
      className={twMerge(
        "gap-2 overflow-y-auto rounded-lg bg-secondary p-2",
        className,
      )}
    />
  );
}
export { ListboxItem };
